import React from 'react';
import { ConsolidatedMetrics } from '@/types';
import { OverTimeChartCard } from './OverTimeChartCard';

interface OverTimeChartsSectionProps {
  data: ConsolidatedMetrics[];
}

const chartConfigs = [
    { metric: 'total_population', title: 'Total Population', category: 'Population', subtitle: 'Total population over time', metricUnits: '' },
    {
      title: 'Newly Permitted Units per 1k Residents',
      category: 'Permitting',
      subtitle: 'Newly permitted units per 1,000 residents over time',
      dataFormatter: (d: ConsolidatedMetrics) => d.bps_total_units / (d.total_population / 1000),
      metricUnits: '',
    },
    { metric: 'housing_stock_growth_if_permits_built_instantly', title: 'Housing Stock Growth', category: 'Housing Stock', subtitle: 'Housing stock growth over time', metricUnits: '%' },
    { metric: 'housing_units_per_1000_residents', title: 'Housing Units per 1k Residents', category: 'Housing Stock', subtitle: 'Housing units per 1,000 residents over time', metricUnits: '' },
    { metric: 'pct_mf_existing', title: 'Multi-Family Housing Stock', category: 'Housing Stock', subtitle: 'Percentage of multi-family housing units', metricUnits: '%' },
    { metric: 'price_to_income', title: 'Price to Income Ratio', category: 'Affordability', subtitle: 'Ratio of median home value to median household income', metricUnits: 'x' },
    { metric: 'rent_burden_share', title: 'Rent Burden', category: 'Affordability', subtitle: 'Percentage of renters who were overburdened', metricUnits: '%' },
    { metric: 'rental_vacancy_rate', title: 'Rental Vacancy Rate', category: 'Housing Market', subtitle: 'Percentage of rental units that are vacant', metricUnits: '%' },
];

export const OverTimeChartsSection: React.FC<OverTimeChartsSectionProps> = ({ data }) => {  
  return (
    <section className="w-full bg-[#F5F5F5]">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32 py-12 sm:py-16 md:py-20">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
          {chartConfigs.map((config) => (
            <OverTimeChartCard
              key={config.title}
              data={data}
              metric={(config as any).metric as keyof ConsolidatedMetrics}
              title={config.title}
              category={config.category}
              subtitle={config.subtitle}
              dataFormatter={(config as any).dataFormatter}
              metricUnits={config.metricUnits}
            />
          ))}
        </div>
      </div>
    </section>
  );
}; 